import watchListAllRelatorioReposicaoEstoqueMinimo from './saga/relatorio';

export const relatorioReposicaoEstoqueMinimoSaga = [
    watchListAllRelatorioReposicaoEstoqueMinimo(),
]

export * from './actionTypes';
export * from './reducer';
export * from './service';
